import PublisherActions from '../actions/PublisherActions';
import PostbackHistoryActions from '../actions/PostbackHistoryActions';
import query from '../helpers/query';
import store from '../stores/redux';
import config from '../config';

const isDevMode = process.env.NODE_ENV === 'development';
const maxCount = 1000;
const minCount = 100;
const maxRequest = 10;
const minRequest = 1;
const events = {
    before: '',
    success: '',
    fail: ''
};

const methodKeys = {
    financeOperations: 'getFinanceOperations',
    conversions: 'getConversions',
    postbackHistory: 'getListHistoryPostbacks'
};

const ExportController = {
    getAllData(key, filter = {}, onSuccess, onError) {
        this[methodKeys[key]](...arguments);
    },

    getFinanceOperations(key, filter, onSuccess, onError) {
        const total = getTotal(store.getState().financeOperations.total);
        const newFilter = query.parseToSend(filter);

        this.makeRequest(PublisherActions, {key, total}, newFilter, onSuccess, onError);
    },

    getConversions(key, filter, onSuccess, onError) {
        const total = getTotal(store.getState().conversions.total);
        const newFilter = query.parseToSend(filter);

        this.makeRequest(PublisherActions, {key, total}, newFilter, onSuccess, onError);
    },

    getListHistoryPostbacks(key, filter, onSuccess, onError) {
        const total = getTotal(store.getState().postbackHistory.total);
        const newFilter = query.parseToSend(filter);

        this.makeRequest(PostbackHistoryActions, {key, total}, newFilter, onSuccess, onError);
    },

    makeRequest(Actions, params = {}, filter, onSuccess, onError) {
        filter.export = 1;

        Actions[methodKeys[params.key]]({
            ...filter,
            count: params.total,
            page: 1
        }, null, events).then(data => {
            if (isDevMode) {
                if (Math.random() > 0.95) {
                    return Promise.reject(new Error('Test query error'));
                }
            }
            if ('financeOperations' === params.key) {
                onSuccess && onSuccess(data);
            } else if ('conversions' === params.key) {
                onSuccess && onSuccess(data);
            }  else if ('postbackHistory' === params.key) {
                onSuccess && onSuccess(data);
            } else {
                onSuccess && onSuccess(data.items, 1, 1);
            }
        }).catch(err => {
            onError && onError(err, 1);
        });
    },
};

const getTotal = (total) => {
    return total * config.itemsCountPerPage;
};

const calcNumberRequests = (total, numberRequests = maxRequest) => {
    let count = total / numberRequests;

    if (count < minCount) {
        if (numberRequests !== minRequest) {
            return calcNumberRequests(total, numberRequests - 1);
        } else {
            return minRequest;
        }
    } else {
        return numberRequests;
    }

    return maxRequest;
};

const calcCountItems = (total, countRequest) => {
    const count = Math.ceil(total / countRequest);

    return count > maxCount ? maxCount : count;
};

export default ExportController;
